import './Project.css'
import { useNavigate  } from 'react-router-dom';
import * as motion from "motion/react-client"
import { AnimatePresence } from 'motion/react';

const Project= ({activeSelector, projectjson}) => {
    const navigate=useNavigate();
    function projectnavigate(routelocation) {
      // Ensure scroll restoration is manual
      navigate.scrollRestoration = 'manual';
    
      // Scroll to the top of the page
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      
      setTimeout(() => {
        navigate(routelocation);
      }, 100); // Small delay to ensure scroll happens first
    }
    
    return (  
    <AnimatePresence>
    <motion.div key={projectjson.post.key} initial={{visibility:"hidden"}} animate={{visibility:"visible"}} exit={{visibility:"hidden"}} className="Project">
      <motion.div  initial={{opacity:0}} animate={{opacity:1}} className='content'>
        <div className='left-flex'>
          <div className='duration'>{projectjson.post.duration}</div>
          <div className='project-title'>
            <div>{projectjson.post.title}</div>
            <div className='sub-title'>{projectjson.post.subtitle}</div>
          </div>
        </div>
        <div className='right-flex' dangerouslySetInnerHTML={{__html:projectjson.post.description}}/>
      </motion.div>
      <div className="project-content">
        
      </div>
      <div className='project-navigation'>
        Other Projects:
        <div className='projects-list'>
        {projectjson.post.key!==0?(<button onClick={()=>{projectnavigate('/project/emonet')}}>Emonet</button>):null}
        {projectjson.post.key!==1?(<button onClick={()=>{projectnavigate('/project/medium')}}>Medium</button>):null}
        {projectjson.post.key!==2?(<button onClick={()=>{projectnavigate('/project/spacemerch')}}>Spacemerch</button>):null}
        {projectjson.post.key!==3?(<button onClick={()=>{projectnavigate('/project/grocer')}}>Grocer Street</button>):null}
        </div>
      </div>
    </motion.div>
    </AnimatePresence>
    );
};

export default Project;